var map = {
	"./activity.js": "lCoe",
	"./appeal.js": "QXmO",
	"./appraiseElect.js": "dhTd",
	"./approval.js": "VTCP",
	"./arms.js": "egZY",
	"./attendance.js": "7qfQ",
	"./base.js": "8Clm",
	"./business.js": "Fphx",
	"./closedLoopSubmitted.js": "5Z+m",
	"./cloudPrinting.js": "UFgD",
	"./complaint.js": "kpHX",
	"./configuration.js": "gC5Z",
	"./constant.js": "6lJy",
	"./counseling.js": "DZmY",
	"./difficultStudent.js": "8SG2",
	"./dorm.js": "oEnG",
	"./equipment.js": "I2g8",
	"./evaluation.js": "g7gJ",
	"./finance.js": "ntdF",
	"./formConfiguration.js": "tNoj",
	"./graduatesLeavingBed.js": "l4fN",
	"./healthy.js": "JWVr",
	"./instructor.js": "2yEF",
	"./notice.js": "JpUi",
	"./order.js": "08+f",
	"./program.js": "c7lR",
	"./punishiment.js": "xjHL",
	"./questionnaire.js": "74w+",
	"./repair.js": "nyk1",
	"./storage.js": "rGnC",
	"./store.js": "rdIs",
	"./student.js": "EQFI",
	"./studentInsurance.js": "qU/Y",
	"./systemSettings.js": "Qttd",
	"./takeToSendLaundry.js": "jEuy",
	"./takeout.js": "8ChA",
	"./test.js": "5KBd",
	"./todo.js": "8s9I",
	"./welcomeNewStudent.js": "hMUH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vm4s";


//////////////////
// WEBPACK FOOTER
// ./src/api/modules nonrecursive [\w-]+\.js$
// module id = Vm4s
// module chunks = 227